import Vue from 'vue';
// 自动注册所有组件
const requireComponent = require.context(
  // 组件目录的相对路径
  '@/components',
  // 是否递归查找子目录
  true,
  // 匹配组件文件名的正则表达式
  /\.vue$/
);

requireComponent.keys().forEach((fileName) => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName);

  // 获取组件的 PascalCase 名称
  const componentName = fileName
    .split('/')
    .pop()
    .replace(/\.\w+$/, '');

  // 全局注册组件
  Vue.component(componentName, componentConfig.default || componentConfig);
});